import { Product, ProductCategory } from '../types/product';

export const products: Product[] = [
  // Vegetables
  {
    id: 'veg-001',
    name: 'Fresh Tomatoes',
    description: 'Locally grown, vine-ripened tomatoes perfect for salads and cooking. Rich in lycopene and vitamins.',
    price: 2.99,
    originalPrice: 3.99,
    category: 'vegetables' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1546094096-0df4bcaaa337?w=500',
      'https://images.unsplash.com/photo-1592924357228-91a4daadcfea?w=500',
    ],
    unit: 'kg',
    inStock: true,
    stockQuantity: 100,
    rating: 4.8,
    reviews: 124,
    featured: true,
    organic: true,
    origin: 'Local Farm',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'veg-002',
    name: 'Fresh Spinach',
    description: 'Organic baby spinach leaves, perfect for salads or cooking. High in iron and vitamins.',
    price: 3.49,
    category: 'vegetables' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=500',
    ],
    unit: 'bunch',
    inStock: true,
    stockQuantity: 50,
    rating: 4.6,
    reviews: 89,
    featured: false,
    organic: true,
    origin: 'Green Valley Farm',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'veg-003',
    name: 'Fresh Carrots',
    description: 'Sweet and crunchy carrots, rich in beta-carotene. Perfect for snacking or cooking.',
    price: 1.99,
    originalPrice: 2.49,
    category: 'vegetables' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1598170845058-32b9d6a5da37?w=500',
    ],
    unit: 'kg',
    inStock: true,
    stockQuantity: 80,
    rating: 4.7,
    reviews: 156,
    featured: true,
    organic: false,
    origin: 'Sunrise Farms',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'veg-004',
    name: 'Fresh Lettuce',
    description: 'Crisp romaine lettuce, perfect for salads and sandwiches. Farm fresh and pesticide-free.',
    price: 2.49,
    category: 'vegetables' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=500',
    ],
    unit: 'head',
    inStock: true,
    stockQuantity: 45,
    rating: 4.5,
    reviews: 78,
    featured: false,
    organic: true,
    origin: 'Organic Gardens',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'veg-005',
    name: 'Fresh Onions',
    description: 'Yellow onions, essential for cooking. Strong flavor and long shelf life.',
    price: 1.49,
    category: 'vegetables' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1518977676601-b53f82aba655?w=500',
    ],
    unit: 'kg',
    inStock: true,
    stockQuantity: 120,
    rating: 4.4,
    reviews: 92,
    featured: false,
    organic: false,
    origin: 'Valley Farms',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'veg-006',
    name: 'Fresh Peppers',
    description: 'Colorful bell peppers, great for salads and cooking. High in Vitamin C.',
    price: 4.99,
    originalPrice: 5.99,
    category: 'vegetables' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1595475207225-428b62bda831?w=500',
    ],
    unit: 'kg',
    inStock: true,
    stockQuantity: 35,
    rating: 4.6,
    reviews: 67,
    featured: false,
    organic: true,
    origin: 'Sunny Acres',
    createdAt: '2024-01-15T10:00:00Z',
  },

  // Fruits
  {
    id: 'fruit-001',
    name: 'Fresh Apples',
    description: 'Crisp and sweet red apples, perfect for snacking. Rich in fiber and antioxidants.',
    price: 4.49,
    originalPrice: 5.49,
    category: 'fruits' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1619546813926-a78fa6372cd2?w=500',
      'https://images.unsplash.com/photo-1570913149827-d2ac84ab3f9a?w=500',
    ],
    unit: 'kg',
    inStock: true,
    stockQuantity: 90,
    rating: 4.9,
    reviews: 203,
    featured: true,
    organic: false,
    origin: 'Mountain Orchards',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'fruit-002',
    name: 'Fresh Bananas',
    description: 'Ripe bananas, perfect for smoothies or as a snack. High in potassium.',
    price: 2.99,
    category: 'fruits' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1603833665858-e61d17a86224?w=500',
    ],
    unit: 'kg',
    inStock: true,
    stockQuantity: 75,
    rating: 4.8,
    reviews: 178,
    featured: true,
    organic: true,
    origin: 'Tropical Farms',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'fruit-003',
    name: 'Fresh Oranges',
    description: 'Juicy Valencia oranges, perfect for fresh juice. High in Vitamin C.',
    price: 3.99,
    originalPrice: 4.99,
    category: 'fruits' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1547514701-42782101795e?w=500',
    ],
    unit: 'kg',
    inStock: true,
    stockQuantity: 65,
    rating: 4.7,
    reviews: 145,
    featured: false,
    organic: false,
    origin: 'Citrus Grove',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'fruit-004',
    name: 'Fresh Mangoes',
    description: 'Sweet and aromatic Alphonso mangoes. The king of fruits!',
    price: 6.99,
    category: 'fruits' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1553279768-865429fa0078?w=500',
    ],
    unit: 'dozen',
    inStock: true,
    stockQuantity: 30,
    rating: 4.9,
    reviews: 89,
    featured: true,
    organic: true,
    origin: 'Sunrise Orchards',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'fruit-005',
    name: 'Fresh Grapes',
    description: 'Seedless green grapes, perfect for snacking. Sweet and refreshing.',
    price: 5.49,
    originalPrice: 6.49,
    category: 'fruits' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1559563362-c667ba5f5480?w=500',
    ],
    unit: 'kg',
    inStock: true,
    stockQuantity: 40,
    rating: 4.6,
    reviews: 112,
    featured: false,
    organic: false,
    origin: 'Vineyard Valley',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'fruit-006',
    name: 'Fresh Watermelon',
    description: 'Juicy watermelon slices, perfect for summer. Hydrating and delicious.',
    price: 4.99,
    category: 'fruits' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1563114773-84221bd62daa?w=500',
    ],
    unit: 'whole',
    inStock: true,
    stockQuantity: 25,
    rating: 4.8,
    reviews: 76,
    featured: false,
    organic: false,
    origin: 'Melon Fields',
    createdAt: '2024-01-15T10:00:00Z',
  },

  // Grains
  {
    id: 'grain-001',
    name: 'Basmati Rice',
    description: 'Premium long-grain basmati rice, perfect for biryanis and pilafs. Aromatic and fluffy.',
    price: 8.99,
    originalPrice: 10.99,
    category: 'grains' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=500',
    ],
    unit: '2kg',
    inStock: true,
    stockQuantity: 60,
    rating: 4.7,
    reviews: 234,
    featured: true,
    organic: false,
    origin: 'Punjab Fields',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'grain-002',
    name: 'Whole Wheat Flour',
    description: 'Stone-ground whole wheat flour, perfect for baking and rotis. Rich in fiber.',
    price: 4.49,
    category: 'grains' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?w=500',
    ],
    unit: '2kg',
    inStock: true,
    stockQuantity: 55,
    rating: 4.5,
    reviews: 167,
    featured: false,
    organic: true,
    origin: 'Organic Mills',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'grain-003',
    name: 'Sweet Corn',
    description: 'Fresh sweet corn, perfect for boiling or grilling. Sweet and tender.',
    price: 2.99,
    category: 'grains' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=500',
    ],
    unit: 'dozen',
    inStock: true,
    stockQuantity: 45,
    rating: 4.6,
    reviews: 98,
    featured: false,
    organic: false,
    origin: 'Corn Fields',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'grain-004',
    name: 'Oats',
    description: 'Rolled oats, perfect for breakfast porridge. High in fiber and energy.',
    price: 3.99,
    originalPrice: 4.99,
    category: 'grains' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1586443119312-86f4123c3eb1?w=500',
    ],
    unit: '500g',
    inStock: true,
    stockQuantity: 70,
    rating: 4.4,
    reviews: 145,
    featured: false,
    organic: true,
    origin: 'Highland Farms',
    createdAt: '2024-01-15T10:00:00Z',
  },

  // Dairy
  {
    id: 'dairy-001',
    name: 'Fresh Milk',
    description: 'Farm-fresh whole milk, pasteurized and homogenized. Rich in calcium.',
    price: 2.49,
    category: 'dairy' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1563636619-e9143da7973b?w=500',
    ],
    unit: 'liter',
    inStock: true,
    stockQuantity: 100,
    rating: 4.8,
    reviews: 312,
    featured: true,
    organic: false,
    origin: 'Dairy Fresh Farm',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'dairy-002',
    name: 'Farm Eggs',
    description: 'Free-range farm eggs, rich in protein. Brown eggs from happy chickens.',
    price: 4.99,
    originalPrice: 5.99,
    category: 'dairy' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1582722872445-44dc5f7e3c8f?w=500',
    ],
    unit: 'dozen',
    inStock: true,
    stockQuantity: 80,
    rating: 4.9,
    reviews: 267,
    featured: true,
    organic: false,
    origin: 'Happy Hen Farm',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'dairy-003',
    name: 'Fresh Cheese',
    description: 'Creamy cottage cheese, perfect for savory dishes. High in protein.',
    price: 5.49,
    category: 'dairy' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1486297678162-eb2a19b0a32d?w=500',
    ],
    unit: '500g',
    inStock: true,
    stockQuantity: 35,
    rating: 4.6,
    reviews: 123,
    featured: false,
    organic: false,
    origin: 'Cheese Makers Co.',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'dairy-004',
    name: 'Greek Yogurt',
    description: 'Creamy Greek yogurt, perfect for breakfast. High protein and probiotics.',
    price: 3.99,
    originalPrice: 4.99,
    category: 'dairy' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=500',
    ],
    unit: '500g',
    inStock: true,
    stockQuantity: 50,
    rating: 4.7,
    reviews: 189,
    featured: false,
    organic: false,
    origin: 'Yogurt Land',
    createdAt: '2024-01-15T10:00:00Z',
  },

  // Poultry
  {
    id: 'poultry-001',
    name: 'Fresh Chicken',
    description: 'Farm-raised chicken, tender and juicy. Perfect for grilling or roasting.',
    price: 7.99,
    originalPrice: 9.99,
    category: 'poultry' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1604503468506-a8da13d82791?w=500',
    ],
    unit: 'kg',
    inStock: true,
    stockQuantity: 45,
    rating: 4.6,
    reviews: 198,
    featured: true,
    organic: false,
    origin: 'Poultry Farms',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'poultry-002',
    name: 'Duck Eggs',
    description: 'Farm-fresh duck eggs, larger than chicken eggs. Richer flavor.',
    price: 6.99,
    category: 'poultry' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1516467508483-a7212febe31a?w=500',
    ],
    unit: 'half dozen',
    inStock: true,
    stockQuantity: 25,
    rating: 4.5,
    reviews: 67,
    featured: false,
    organic: false,
    origin: 'Duck Pond Farm',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'poultry-003',
    name: 'Turkey Pieces',
    description: 'Lean turkey pieces, perfect for stews and roasting. Low fat, high protein.',
    price: 9.99,
    category: 'poultry' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1604503468506-a8da13d82791?w=500',
    ],
    unit: 'kg',
    inStock: false,
    stockQuantity: 0,
    rating: 4.4,
    reviews: 45,
    featured: false,
    organic: false,
    origin: 'Turkey Valley',
    createdAt: '2024-01-15T10:00:00Z',
  },

  // Herbs
  {
    id: 'herb-001',
    name: 'Fresh Basil',
    description: 'Aromatic basil leaves, essential for Italian cooking. Perfect for pesto and salads.',
    price: 2.99,
    category: 'herbs' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1618375569909-3c8616cf7733?w=500',
    ],
    unit: 'bunch',
    inStock: true,
    stockQuantity: 40,
    rating: 4.8,
    reviews: 156,
    featured: false,
    organic: true,
    origin: 'Herb Gardens',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'herb-002',
    name: 'Fresh Coriander',
    description: 'Fresh coriander leaves, essential for Asian and Mexican cuisine. Vibrant flavor.',
    price: 1.99,
    category: 'herbs' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1618375569909-3c8616cf7733?w=500',
    ],
    unit: 'bunch',
    inStock: true,
    stockQuantity: 35,
    rating: 4.7,
    reviews: 134,
    featured: false,
    organic: true,
    origin: 'Green Thumb Farm',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'herb-003',
    name: 'Fresh Mint',
    description: 'Refreshing mint leaves, perfect for beverages and desserts. Cooling and aromatic.',
    price: 2.49,
    category: 'herbs' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1628624747186-a941c476b7ef?w=500',
    ],
    unit: 'bunch',
    inStock: true,
    stockQuantity: 30,
    rating: 4.6,
    reviews: 98,
    featured: false,
    organic: true,
    origin: 'Mint Plantation',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'herb-004',
    name: 'Fresh Rosemary',
    description: 'Fragrant rosemary sprigs, perfect for roasting meats and potatoes. Woody aroma.',
    price: 2.99,
    category: 'herbs' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1595246140625-573b715d11dc?w=500',
    ],
    unit: 'bunch',
    inStock: true,
    stockQuantity: 25,
    rating: 4.5,
    reviews: 76,
    featured: false,
    organic: true,
    origin: 'Mediterranean Herbs',
    createdAt: '2024-01-15T10:00:00Z',
  },

  // Legumes
  {
    id: 'legume-001',
    name: 'Red Kidney Beans',
    description: 'Premium red kidney beans, perfect for curries and salads. High protein.',
    price: 3.49,
    originalPrice: 4.49,
    category: 'legumes' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1600096194534-95cf5ece04cf?w=500',
    ],
    unit: '1kg',
    inStock: true,
    stockQuantity: 55,
    rating: 4.6,
    reviews: 145,
    featured: false,
    organic: false,
    origin: 'Legume Farms',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'legume-002',
    name: 'Chickpeas',
    description: 'Premium chickpeas, essential for hummus and curries. Creamy texture.',
    price: 3.99,
    category: 'legumes' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1598133894008-61f7fdb8cc3a?w=500',
    ],
    unit: '1kg',
    inStock: true,
    stockQuantity: 50,
    rating: 4.7,
    reviews: 167,
    featured: false,
    organic: true,
    origin: 'Organic Pulse Co.',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'legume-003',
    name: 'Lentils',
    description: 'Split red lentils, quick cooking and perfect for soups. Rich in iron.',
    price: 2.99,
    originalPrice: 3.49,
    category: 'legumes' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=500',
    ],
    unit: '1kg',
    inStock: true,
    stockQuantity: 60,
    rating: 4.5,
    reviews: 123,
    featured: false,
    organic: false,
    origin: 'Pulse Fields',
    createdAt: '2024-01-15T10:00:00Z',
  },

  // Seeds
  {
    id: 'seed-001',
    name: 'Sunflower Seeds',
    description: 'Premium sunflower seeds for planting. High germination rate.',
    price: 4.99,
    category: 'seeds' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=500',
    ],
    unit: '500g',
    inStock: true,
    stockQuantity: 35,
    rating: 4.4,
    reviews: 56,
    featured: false,
    organic: true,
    origin: 'Seed Masters',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'seed-002',
    name: 'Pumpkin Seeds',
    description: 'Organic pumpkin seeds, perfect for snacking or planting. Nutritious.',
    price: 5.99,
    originalPrice: 6.99,
    category: 'seeds' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1506368249639-73a05d6f6488?w=500',
    ],
    unit: '500g',
    inStock: true,
    stockQuantity: 30,
    rating: 4.6,
    reviews: 78,
    featured: false,
    organic: true,
    origin: 'Pumpkin Patch',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'seed-003',
    name: 'Tomato Seeds',
    description: 'Heirloom tomato seeds for your garden. Variety of colors and flavors.',
    price: 3.99,
    category: 'seeds' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1592841200221-a6898f307baa?w=500',
    ],
    unit: 'packet',
    inStock: true,
    stockQuantity: 45,
    rating: 4.7,
    reviews: 89,
    featured: true,
    organic: true,
    origin: 'Heritage Seeds',
    createdAt: '2024-01-15T10:00:00Z',
  },
  {
    id: 'seed-004',
    name: 'Chili Seeds',
    description: 'Hot chili seeds for growing your own peppers. Various heat levels.',
    price: 2.99,
    category: 'seeds' as ProductCategory,
    images: [
      'https://images.unsplash.com/photo-1522069169874-c58ec4b76be5?w=500',
    ],
    unit: 'packet',
    inStock: true,
    stockQuantity: 40,
    rating: 4.5,
    reviews: 67,
    featured: false,
    organic: true,
    origin: 'Chili Masters',
    createdAt: '2024-01-15T10:00:00Z',
  },
];

export const getProductById = (id: string): Product | undefined => {
  return products.find(product => product.id === id);
};

export const getProductsByCategory = (category: ProductCategory): Product[] => {
  return products.filter(product => product.category === category);
};

export const getFeaturedProducts = (): Product[] => {
  return products.filter(product => product.featured);
};

export const getProductsByIds = (ids: string[]): Product[] => {
  return products.filter(product => ids.includes(product.id));
};

